export enum EClaimBusinessSteps {
  ACTIVATION_CODE = 'activationCode',
  COMPANY_DETAILS = 'companyDetails',
}
